var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.546875 0.546876V11.2656H4.8125L7 13.4531L9.1875 11.2656H13.4531V0.546876H0.546875Z",
    stroke: "#1B1B1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99915 2.7344L8.02974 4.82262L10.3342 5.1575L8.66668 6.78295L9.06035 9.07812L6.99915 7.99449L4.93795 9.07812L5.33162 6.78295L3.66406 5.1575L5.96857 4.82262L6.99915 2.7344Z",
    stroke: "#1B1B1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoIcon);
export default __webpack_public_path__ + "static/media/favoIcon.2c25457f133967a4bfb94fa1eb6b8001.svg";
export { ForwardRef as ReactComponent };